// import useFeatureToggle from "hooks/useFeatureToggle";
// import useScreenBreakpoint from "./hooks/useScreenBreakpoint";
import { Button } from "nectar-ui";
import React from "react";
import EmptyStateDashboardSinglePage from "../../../svg/illustration/EmptyStateDashboardSinglePage";

// TODO: import useFeatureToggle and useScreenBreakpoint from package
// import { sendEventEmptyStateClick } from "./services/dashboard-module/dashboardAnalyticEventService";
import { dashboardChartEmptyStatesTypes } from "../../../utils/constants/dashboard/analyticDashboardEvents";
import {
  EmptyStateWrapper,
  StyledHeading,
  StyledLinkButton,
  StyledText,
  TextWrapper,
} from "./style";

const DashboardSinglePageEmptyState = () => {
  const HELP_CENTRAL_LINK =
    "https://astrea.aurum.com.br/pt-BR/articles/8066996-conheca-os-indicadores-do-astrea";

  // const hasRefactoredPlanAccess = useFeatureToggle("refactored-plan-module");

  const handleDiscoverPlansClick = () => {
    // sendEventEmptyStateClick(dashboardChartEmptyStatesTypes.DISCOVER_NEW_PLANS);
    // if (hasRefactoredPlanAccess) window.open("#/main/plan-module/comparison-page", "_self");
    if (true) window.open("#/main/plan-module/comparison-page", "_self");
    else window.open("#/main/planNew/plan/add-edit/%5Btrue,false,%5D", "_self");
  };

  const sendMixPanelWhenClickToHelpCenter = () => {
    // sendEventEmptyStateClick(dashboardChartEmptyStatesTypes.HELP_CENTER);
  };

  // const { isMobileScreen } = useScreenBreakpoint();
  const isMobileScreen = false;

  return (
    <EmptyStateWrapper>
      <EmptyStateDashboardSinglePage mobile={isMobileScreen} />
      <TextWrapper mobile={isMobileScreen}>
        <StyledHeading size="xs" semiBold>
          Acompanhe os dados mais relevantes do escritório
        </StyledHeading>
        <StyledText size="md">
          Conheça outros planos para ter uma visão ampla dos resultados do dia a dia, fundamentar
          decisões e criar estratégias para impulsionar o crescimento do escritório.
        </StyledText>
      </TextWrapper>
      <Button color="primary" onClick={handleDiscoverPlansClick}>
        Conhecer Planos
      </Button>
      <StyledLinkButton
        onClick={sendMixPanelWhenClickToHelpCenter}
        href={HELP_CENTRAL_LINK}
        target="_blank"
        link
      >
        Saiba mais sobre o módulo de indicadores
      </StyledLinkButton>
    </EmptyStateWrapper>
  );
};

export default DashboardSinglePageEmptyState;
